import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { BRAND_THEME } from "@/lib/constants";
import { Card } from "@/components/common";

const axis = { tick: { fontSize: 12, fill: "#64748B" }, axisLine: false, tickLine: false };

export const CategoryCard = ({ data, compare, brand }) => {
  const rows = data.filter((c) => c.count || (compare && c.prev)).slice(0, 8);
  return (
    <Card title="What customers complain about" subtitle="Negative feedback by issue type" testid="category-card">
      {!rows.length ? <p className="py-16 text-center text-sm text-slate-400">No negative feedback in this period.</p> : (
        <ResponsiveContainer width="100%" height={Math.max(220, 34 * rows.length + 40)}>
          <BarChart data={rows} layout="vertical" margin={{ left: 8, right: 16 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#F1F5F9" horizontal={false} />
            <XAxis type="number" {...axis} allowDecimals={false} />
            <YAxis type="category" dataKey="name" {...axis} width={150} />
            <Tooltip contentStyle={{ borderRadius: 12, border: "1px solid #E2E8F0" }} />
            {compare && <Legend wrapperStyle={{ fontSize: 12 }} />}
            {compare && <Bar dataKey="prev" name="Previous period" fill="#94A3B8" radius={[0, 6, 6, 0]} maxBarSize={14} />}
            <Bar dataKey="count" name="This period" fill={BRAND_THEME[brand].primary} radius={[0, 6, 6, 0]} maxBarSize={14} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
};
